import React from 'react';
import { workholdingExplanation, workholdingRatings, workholdingRows } from '../../data/workholdingChart';
export function WorkholdingChart() {
  return <div data-id="element-593" data-mp="lk2clpl62hxl">
      <p className="font-mono text-[11px] leading-relaxed tracking-[0.04em] text-graphite/80" data-id="element-594" data-mp="gqzqg2ipyarf">
        6061-T6 aluminum · APGX 331R MG12 or APGX 332R MG12 · Rows: DOC per
        side (in) · Columns: workholding security rating 1–10 (10 = most
        secure) · Values: feed (IPR) · X = not recommended
      </p>

      <p aria-hidden="true" className="mt-4 font-mono text-[10.5px] tracking-[0.06em] text-copper lg:hidden" data-id="element-595" data-mp="2ri0vkxlmth0">
        Scroll the chart sideways to see all ratings →
      </p>

      <div role="region" aria-labelledby="workholding-chart-caption" tabIndex={0} className="mt-3 overflow-x-auto border border-rule bg-white" data-id="element-596" data-mp="3oyonaawx14am">
        <table className="w-full min-w-[760px] border-collapse text-center" data-id="element-597" data-mp="1n720klk23vjy">
          <caption id="workholding-chart-caption" className="sr-only" data-id="element-598" data-mp="1n4z1lc0xes33">
            Security of workholding: feed in inches per revolution by depth of
            cut per side and workholding security rating, for 6061-T6 aluminum
            with APGX 331R MG12 or APGX 332R MG12. X means not recommended.
          </caption>
          <thead data-id="element-599" data-mp="29oj854vbyy4w">
            <tr className="bg-navy" data-id="element-600" data-mp="29nzva2kjezxq">
              <th scope="col" rowSpan={2} className="sticky left-0 z-10 border-r border-white/10 bg-navy px-4 py-3 text-left font-mono text-[10px] font-medium tracking-label text-aluminum" data-id="element-601" data-mp="29p1dqs3vuoph">
                DOC PER SIDE (IN)
              </th>
              <th scope="colgroup" colSpan={10} className="border-b border-white/10 px-4 py-2.5 font-mono text-[10px] font-medium tracking-label text-aluminum" data-id="element-602" data-mp="2no0u7ch8rxak">
                SECURITY OF WORKHOLDING (1 = LEAST SECURE, 10 = MOST SECURE)
              </th>
            </tr>
            <tr className="bg-navy" data-id="element-603" data-mp="3uzevzgoaclua">
              {workholdingRatings.map(r => <th key={r} scope="col" className="border-r border-white/10 px-2 py-2.5 font-mono text-[12px] font-medium text-white last:border-r-0" data-id="element-604" data-mp="3q0keqj5yv5ca">
                  {r}
                </th>)}
            </tr>
          </thead>
          <tbody data-id="element-605" data-mp="3c0j3qavzmhj3">
            {workholdingRows.map(row => <tr key={row.doc} className="border-t border-rule" data-id="element-606" data-mp="3c2vt3942ru66">
                <th scope="row" className="sticky left-0 z-10 border-r border-rule bg-white px-4 py-3 text-left font-mono text-[13px] font-medium text-navy" data-id="element-607" data-mp="3791a67wanj85">
                  {row.doc}
                </th>
                {row.feeds.map((feed, i) => <td key={workholdingRatings[i]} className={`rp-tabular border-r border-rule px-2 py-3 font-mono text-[13px] last:border-r-0 ${feed ? 'text-graphite' : 'bg-warm text-graphite/60'}`} data-id="element-608" data-mp="2t9032apfrfk8" data-mpi={i}>
                    {feed ?? <>
                        <span aria-hidden="true" data-id="element-609" data-mp="1dqu16acoao9t">X</span>
                        <span className="sr-only" data-id="element-610" data-mp="1dp95ghemgzad">Not recommended</span>
                      </>}
                  </td>)}
              </tr>)}
          </tbody>
        </table>
      </div>

      <div className="rp-measure mt-6 border-l-2 border-copper bg-warm px-5 py-4" data-id="element-611" data-mp="q1j699i07o3l">
        <p className="text-[14px] leading-[1.7] text-graphite/90" data-id="element-612" data-mp="u3e76cw0vzgu">
          {workholdingExplanation}
        </p>
      </div>
    </div>;
}